/**
 * Product Accordion
 * Desktop (768px+): Content floats upward as overlay
 * Mobile (<768px): Standard collapsible, content opens below and pushes down
 *
 * Reviews + Judge.me: widget starts empty and hydrates via Judge.me JS.
 * Hidden visibility breaks init, so Reviews uses height-only collapse + reinit on open.
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  function initAccordion() {
    var accordionItems = document.querySelectorAll('.accordion-item');
    if (!accordionItems.length) return;

    accordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        toggleAccordion(item);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(item);
        }
      });
    });

    function toggleAccordion(item) {
      if (item.classList.contains('active')) {
        closeAccordion(item);
      } else {
        closeAllAccordions();
        openAccordion(item);
      }
    }

    function setOverlayHeight(item) {
      var overlay = item.querySelector('.accordion-overlay');
      var overlayContent = item.querySelector('.accordion-overlay-content');
      if (!overlay || !overlayContent) return;

      var isReviews = item.getAttribute('data-accordion') === 'review-returns';
      var measured = overlayContent.scrollHeight + 40;
      var minHeight = isReviews ? 520 : 0;
      overlay.style.maxHeight = Math.max(measured, minHeight) + 'px';
    }

    function reinitJudgeMe() {
      try {
        if (typeof window.jdgm_preloader === 'function') {
          window.jdgm_preloader();
          return;
        }
        if (window.jdgm) {
          if (typeof window.jdgm.customizeWidgets === 'function') {
            window.jdgm.customizeWidgets();
          }
          if (typeof window.jdgm.reloadAllWidgets === 'function') {
            window.jdgm.reloadAllWidgets();
          }
          if (typeof window.jdgm.loadWidgets === 'function') {
            window.jdgm.loadWidgets();
          }
        }
      } catch (err) {
        // Ignore until Judge.me scripts finish loading
      }
    }

    function refreshJudgeMe(item) {
      if (item.getAttribute('data-accordion') !== 'review-returns') return;

      reinitJudgeMe();

      [200, 600, 1200, 2500, 4000].forEach(function (delay) {
        setTimeout(function () {
          if (!item.classList.contains('active')) return;
          reinitJudgeMe();
          setOverlayHeight(item);
        }, delay);
      });

      var reviewRoot = item.querySelector('#review-content, #judgeme_product_reviews');
      if (!reviewRoot || typeof MutationObserver === 'undefined') return;

      if (item._jdgmObserver) item._jdgmObserver.disconnect();

      item._jdgmObserver = new MutationObserver(function () {
        if (item.classList.contains('active')) setOverlayHeight(item);
      });
      item._jdgmObserver.observe(reviewRoot, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    function openAccordion(item) {
      var trigger = item.querySelector('.accordion-trigger');
      var overlay = item.querySelector('.accordion-overlay');
      var overlayContent = item.querySelector('.accordion-overlay-content');
      if (!overlay || !overlayContent) return;

      item.classList.add('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      setOverlayHeight(item);
      refreshJudgeMe(item);
    }

    function closeAccordion(item) {
      var trigger = item.querySelector('.accordion-trigger');
      var overlay = item.querySelector('.accordion-overlay');
      if (!overlay) return;

      item.classList.remove('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      overlay.style.maxHeight = '0';

      if (item._jdgmObserver) {
        item._jdgmObserver.disconnect();
        item._jdgmObserver = null;
      }
    }

    function closeAllAccordions() {
      accordionItems.forEach(function (item) {
        if (item.classList.contains('active')) closeAccordion(item);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        accordionItems.forEach(function (item) {
          if (item.classList.contains('active')) setOverlayHeight(item);
        });
      }, 250);
    });

    document.addEventListener('jdgm.doneSetup', function () {
      accordionItems.forEach(function (item) {
        if (
          item.classList.contains('active') &&
          item.getAttribute('data-accordion') === 'review-returns'
        ) {
          setOverlayHeight(item);
        }
      });
    });

    // Warm Judge.me once scripts are available (widget lives in Reviews panel)
    var warmTries = 0;
    var warmTimer = setInterval(function () {
      warmTries += 1;
      if (window.jdgm || typeof window.jdgm_preloader === 'function') {
        reinitJudgeMe();
        clearInterval(warmTimer);
      } else if (warmTries >= 40) {
        clearInterval(warmTimer);
      }
    }, 250);
  }
})();
